import React from 'react';
import clsx from 'clsx';
import { ReviewItem, SanityKeyed } from 'types/studio/studio';
import { RatingStars, Typography } from '@ag1/ui';
import { vars } from '@ag1/ui/theme';
import styles from './styles.module.scss';

type ReviewsCardProps = SanityKeyed<ReviewItem> & {
  textColor?: string;
  showIndividualReviewBackground: boolean;
};

const ReviewsCard = ({
  title,
  text,
  author,
  textColor: textColorProp,
  showIndividualReviewBackground,
  disableRating,
  rating = 0
}: ReviewsCardProps) => {
  const textColor =
    textColorProp && textColorProp in vars.colors.text
      ? vars.colors.text[textColorProp as keyof typeof vars.colors.text]
      : vars.colors.text.primary;

  return (
    <article
      className={clsx(styles.root, {
        [styles.noBackground]: !showIndividualReviewBackground
      })}>
      <div className={styles.main}>
        {!disableRating && (
          <RatingStars
            rating={rating}
            className={styles.ratingStars}
            childClassName={styles.padding}
            inheritFontSize
            thin
            offset={4}
          />
        )}
        {title && (
          <Typography
            component="h3"
            variant="subtitle"
            size="1"
            weight="700"
            noPadding
            className={styles.title}
            style={{ color: textColor }}>
            {title}
          </Typography>
        )}
        <Typography
          variant="body"
          size="1"
          weight="400"
          className={styles.text}
          noPadding
          style={{ color: textColor }}>
          {text}
        </Typography>
      </div>
      {author && (
        <Typography
          component="p"
          variant="bodyMono"
          className={clsx(styles.authorText, {
            [styles.authorTextInverse]: textColorProp === 'primaryInverse'
          })}
          size="2"
          weight="400"
          color="grey-1-new"
          noPadding>
          {author}
        </Typography>
      )}
    </article>
  );
};

export default ReviewsCard;
